// LoadingOverlay.js
import React from "react";
import { Block } from "baseui/block";
import { Layer } from "baseui/layer";
import { ExtraLargeSpinner } from "../styled-components/StyledComponents";
const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <Layer>
      <Block
        display="flex"
        justifyContent="center"
        alignItems="center"
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        backgroundColor="rgba(255, 255, 255, 0.9)" // Adjust opacity as needed
      >
        <ExtraLargeSpinner />
      </Block>
    </Layer>
  );
};

export default LoadingOverlay;
